import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRoom = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	},
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		transform: "matrix(0.898931,0,0,0.858686,12.590148,21.407689)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0,-21.867L7.266,-21.867C7.266,-21.867 10.236,-21.841 10.269,-18.892",
			style: {
				fill: "none",
				fillRule: "nonzero",
				stroke: "currentColor",
				strokeWidth: "2.15px"
			}
		})
	}), /* @__PURE__ */ _jsx("g", {
		transform: "matrix(0.898931,0,0,0.858686,12.590148,21.407689)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M10.269,-18.892L10.269,-3.012C10.269,-1.348 9.002,0 7.441,0L-8.754,0C-10.316,0 -11.582,-1.348 -11.582,-3.012L-11.582,-18.855C-11.582,-20.518 -10.316,-21.867 -8.754,-21.867L-6.088,-21.867L-2.654,-18.432",
			style: {
				fill: "none",
				fillRule: "nonzero",
				stroke: "currentColor",
				strokeWidth: "2.15px"
			}
		})
	})]
});
export default SvgRoom;
